module.exports = __webpack_public_path__ + "static/media/4_Jens_Winter_Zertifikate.f8af5546.jpg";